import { render, staticRenderFns } from "./EchartsNew.vue?vue&type=template&id=4c836aaf&scoped=true&"
import script from "./EchartsNew.vue?vue&type=script&lang=js&"
export * from "./EchartsNew.vue?vue&type=script&lang=js&"
import style0 from "./EchartsNew.vue?vue&type=style&index=0&id=4c836aaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c836aaf",
  null
  
)

export default component.exports